@if (note() >= 0) {
  <div class="flex gap-x-1 text-anis">
    @let isMobile = breakpoints() === "mobile";
    @let widthAndHeight = size() === "SMALL" ? 18 : isMobile ? 30 : 40;
    @for (src of stars(); track index; let index = $index) {
      <span class="relative inline-block fill-transparent">
        <app-svg [inline]="true" [src]="src" [width]="widthAndHeight" [height]="widthAndHeight" />
      </span>
    }
  </div>
}
